import MainLayout from '@/shared/components/layouts/MainLayout';
import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';

// Lazy load pages for code splitting
const HomePage = lazy(() => import('@/features/home/pages/HomePage'));
const AboutPage = lazy(() => import('@/features/about/pages/AboutPage'));
const SustainabilityPage = lazy(
  () => import('@/features/sustainability/pages/SustainabilityPage')
);

// Healthcare pages
const HealthcarePage = lazy(
  () => import('@/features/healthcare/pages/HealthcarePage')
);
const HospitalPage = lazy(
  () => import('@/features/healthcare/pages/HospitalPage')
);
const CenterOfExcellencePage = lazy(
  () => import('@/features/healthcare/pages/CenterOfExcellencePage')
);
const CenterOfExcellenceDetailPage = lazy(
  () => import('@/features/healthcare/pages/CenterOfExcellenceDetailPage')
);

// Wellness pages
const WellnessPage = lazy(
  () => import('@/features/wellness/pages/WellnessPage')
);
const WellnessDetailPage = lazy(
  () => import('@/features/wellness/pages/WellnessDetailPage')
);

// Accommodations pages
const AccommodationPage = lazy(
  () => import('@/features/accommodation/pages/AccommodationPage')
);
const AccommodationDetailPage = lazy(
  () => import('@/features/accommodation/pages/AccommodationDetailPage')
);
// Legacy accommodation pages (unused)

// Venue pages
const VenuePage = lazy(() => import('@/features/venue/pages/VenuePage'));
const BBCCPage = lazy(() => import('@/features/venue/pages/BBCCPage'));
const MeetingRoomPage = lazy(
  () => import('@/features/venue/pages/MeetingRoomPage')
);
const DiningPage = lazy(() => import('@/features/venue/pages/DiningPage'));
const ShopPage = lazy(() => import('@/features/venue/pages/ShopPage'));

// Shared components
const NotFound = lazy(() => import('@/shared/components/NotFound'));

export const router = createBrowserRouter([
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'about', element: <AboutPage /> },
      { path: 'sustainability', element: <SustainabilityPage /> },

      // Healthcare routes
      { path: 'healthcare', element: <HealthcarePage /> },
      { path: 'healthcare/hospital', element: <HospitalPage /> },
      {
        path: 'healthcare/hospital/:name',
        element: <CenterOfExcellencePage />,
      },
      {
        path: 'healthcare/international/:slug',
        element: <CenterOfExcellenceDetailPage />,
      },
      { path: 'healthcare/coe', element: <CenterOfExcellencePage /> },

      // Wellness routes
      { path: 'wellness', element: <WellnessPage /> },
      { path: 'wellness/:name', element: <WellnessDetailPage /> },

      // Accommodations routes
      { path: 'accomodation', element: <AccommodationPage /> },
      { path: 'accomodation/:slug', element: <AccommodationDetailPage /> },

      // Venue routes
      { path: 'venue', element: <VenuePage /> },
      { path: 'venue/bali-beach-convention-center', element: <BBCCPage /> },
      { path: 'venue/meeting-rooms', element: <MeetingRoomPage /> },
      { path: 'venue/dining', element: <DiningPage /> },
      { path: 'venue/shop', element: <ShopPage /> },

      // 404 route
      { path: '*', element: <NotFound /> },
    ],
  },
]);
